/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */
import {
  useQuery,
  type DataTag,
  type QueryClient,
  type QueryFunction,
  type QueryKey,
  type UseQueryOptions,
  type UseQueryReturnType,
} from "@tanstack/vue-query"
import { toValue, unref, type MaybeRefOrGetter } from "vue"

import { customInstance, type ErrorType } from ".././client.ts"
import { useQueryOptions } from ".././queryOptions.ts"
import type {
  Error,
  GetReferralInformationParams,
  ReferralInformationResponse,
} from "../model"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Get referral information by referrer code
 */
export const getReferralInformation = (
  params: MaybeRefOrGetter<GetReferralInformationParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = toValue(params)

  return customInstance<ReferralInformationResponse>(
    { url: `/api/v1/referral`, method: "GET", params, signal },
    options,
  )
}

export const getGetReferralInformationQueryKey = (
  params?: MaybeRefOrGetter<GetReferralInformationParams>,
) => {
  return ["api", "v1", "referral", ...(params ? [params] : [])] as const
}

export const useGetReferralInformationQueryOptions = <
  TData = Awaited<ReturnType<typeof getReferralInformation>>,
  TError = ErrorType<Error>,
>(
  params: MaybeRefOrGetter<GetReferralInformationParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReferralInformation>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetReferralInformationQueryKey(params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getReferralInformation>>
  > = ({ signal }) => getReferralInformation(params, requestOptions, signal)

  const customOptions = useQueryOptions(
    { queryKey, queryFn, ...queryOptions },
    { params },
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof getReferralInformation>>,
    TError,
    TData
  >
}

export type GetReferralInformationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReferralInformation>>
>
export type GetReferralInformationQueryError = ErrorType<Error>

/**
 * @summary Get referral information by referrer code
 */

export function useGetReferralInformation<
  TData = Awaited<ReturnType<typeof getReferralInformation>>,
  TError = ErrorType<Error>,
>(
  params: MaybeRefOrGetter<GetReferralInformationParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReferralInformation>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useGetReferralInformationQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}
